<template>
  <div>
    <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
  </div>
</template>

<script>

export default {
  data () {
    return {
      authConfig: {
        hideAllDefaults: false,
        signInConfig: {
          isSignUpDisplayed: false
        },
        signUpConfig: {
          hiddenDefaults: ['phone_number'],
        },
      },
    }
  },
}

</script>
